const SEEDS = [
  [6, 38, 14], [18, 22, 18], [31, 54, 11], [44, 30, 16], [57, 64, 13],
  [69, 26, 20], [81, 46, 12], [92, 34, 17], [12, 70, 15], [74, 80, 19],
];

export const Bubbles = ({ count = 10, className = "" }) => (
  <div aria-hidden className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
    {SEEDS.slice(0, count).map(([left, size, dur], i) => (
      <span
        key={i}
        className="bubble"
        style={{ left: `${left}%`, bottom: "-80px", width: size, height: size, animationDuration: `${dur}s`, animationDelay: `${i * 1.3}s` }}
      />
    ))}
  </div>
);
